import React, {Component} from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row} from "antd";
import UserSmall from "../../Boilerplate/UserSmall";
import {compose} from "redux";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {canUpdate} from "../../Boilerplate/permissions";
import {SubmittalFiles} from "./SubmittalFiles";
import ChatWall from "../../Boilerplate/ChatWall";
import {compArr} from "../selectors";
import DateTimeDisplay from "../../Boilerplate/DateTimeDisplay";

class SubmittalDetail extends Component {
  render() {
    const { submittal, projectId, onEdit } = this.props;
    const rowWidth = 24;
    const keyWidth = 11;
    const valWidth = rowWidth - keyWidth;
    return (
      <Row gutter={24}>
        <Col span={17}>
          <Card
            className='bid-dashboard-info'
            title={`Submittal #${submittal.resource.number} - ${submittal.resource.title}`}
            extra={
              <Button.Group>
                <Button onClick={onEdit} disabled={!canUpdate(submittal)}>Edit</Button>
              </Button.Group>
            }
          >
            <Row>
              <Col span={12}>
                <Row className='key-value'>
                  <Col span={keyWidth}>Assigned To</Col>
                  <Col span={valWidth}><UserSmall id={submittal.resource.owneruserid}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Due</Col>
                  <Col span={valWidth}><DateDisplay date={submittal.resource.duedate}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Status</Col>
                  <Col span={valWidth}><CodeTag table='submittalstatus' code={submittal.resource.status}/></Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={18} className='rfi-question-response'>
              <Col span={12}>
                <Card type='inner' title='Description' style={{ marginBottom: '16px' }}>
                  <p className='formatted-text'>{submittal.resource.description}</p>
                  Created by <UserSmall id={submittal.resource.createdbyuserid}/> at <DateTimeDisplay date={submittal.resource.datecreated}/>
                </Card>
              </Col>
              <Col span={12}>
                <Card type='inner' title='Response' style={{ marginBottom: '16px' }}>
                  <p className='formatted-text'>{submittal.resource.reply}</p>
                  {submittal.resource.reply && submittal.resource.replyuserid && submittal.resource.replydatetime &&
                  <span>Reply by <UserSmall id={submittal.resource.replyuserid}/> at <DateTimeDisplay date={submittal.resource.replydatetime}/></span>}
                </Card>
              </Col>
            </Row>
            <div>
              <Divider>CSI Codes</Divider>
              <div>
                {submittal.resource.csicodes && submittal.resource.csicodes.map(code => (
                  <CodeTag table='csi' key={code} code={code}/>
                  ))}
              </div>
            </div>
          </Card>
          <SubmittalFiles/>
        </Col>
        <Col span={7}>
          <ChatWall projectId={projectId} submittalId={submittal.resource.id}/>
          {/*<Activity/>*/}
        </Col>
      </Row>
    );
  }
}

export default compose(
  connect(
    (state, props) => {
      let projectId = props.match.params.id;
      let submittal = state.view.subview.data[props.match.params.submittalId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'submittals', props.match.params.submittalId];
      if (!compArr(path, itempath) || loading || !submittal) return { loading: true };
      return { submittal, projectId };
    },
    (dispatch, props) => ({
      onEdit: () => props.history.push(`/projects/${props.match.params.id}/submittals/${props.match.params.submittalId}/edit`)
    })
  ),
)(SubmittalDetail);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/SubmittalDetail.js